import { render, staticRenderFns } from "./larp_teams.vue?vue&type=template&id=6d225e29"
import script from "./larp_teams.vue?vue&type=script&lang=js"
export * from "./larp_teams.vue?vue&type=script&lang=js"
import style0 from "./larp_teams.vue?vue&type=style&index=0&id=6d225e29&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports